<template>
    <el-dropdown :popper-class="popperClass" placement="bottom-end" :hide-timeout="200" ref="userDropMenuRef">
        <div class="nav-item pointer" @click="goPage('userHomePage')">
            <img class="user-img" :src="currentUser?.icon || config.defaultImg" alt="" />
            <span class="user-name" :title="username.length<=3? '': username">{{ shortName }}</span>
        </div>
        <template #dropdown>
            <div class="dropdown-menu-box" @mouseenter="userDropMenuMouseOver">
                <div class="menu-header flex-between" @click="goPage('userHomePage')">
                    <div class="flex-start">
                        <img class="user-img" :src="currentUser?.icon || config.defaultImg" alt="" />
                        <span class="user-name" :title="username">{{ username }}</span>
                    </div>
                    <!-- <div class="personal-nav" v-if="showPersonCenter">
                        <span>个人中心</span>
                        <i class="iconfont icon-gerenzhongxin-you"></i>
                    </div> -->
                </div>
                <div class="menu-box" v-if="applications.length || showManage || showStrain">
                    <div class="application-menu" v-if="applications.length">
                        <div class="application-header">
                            我的应用
                        </div>
                        <ul class="application-list">
                            <li class="application-item flex-start" v-for="item in applications" :key="item.id" @click="goPage(item.route.name)">
                                <img class="application-icon" :src="item.icon" alt="" />{{item.shortTitle}}
                            </li>
                        </ul>
                    </div>
                    <div class="drop-menu-item flex-between" v-if="showStrain" @click="goSelfUrl('strain.index')">
                        <span>培训管理系统</span>
                        <i class="iconfont icon-gerenzhongxin-you"></i>
                    </div>
                    <div class="drop-menu-item flex-between" v-if="showManage" @click="goSelfUrl('idxmc.index')">
                        <span>管理中心</span>
                        <i class="iconfont icon-gerenzhongxin-you"></i>
                    </div>
                    <!-- <div class="drop-menu-item security flex-between" @click="goPage('accountSecurity')">
                        <span>账号安全</span>
                        <i class="iconfont icon-gerenzhongxin-you"></i>
                    </div> -->
                    <div class="site-list-menu" v-if="personalInstitutions.length > 1 && showSiteList">
                        <div class="site-header">
                            我的站点
                        </div>
                        <el-dropdown trigger="hover" popper-class="site-drop-menu" placement="right-start">
                            <div class="current-site">
                                <img :src="currentInstitution.favicon" class="logo" alt="">
                                <span class="title" :title="currentInstitution.institutionName">{{ currentInstitution.institutionName ?? '-' }}</span>
                                <img src="~@/assets/img/home/banner-right.png" class="arrow-right-icon" alt="">
                            </div>
                            <template #dropdown>
                                <div class="site-menu-box" @mouseenter="siteMenuMouseOver" @mouseleave="siteMenuMouseLeave">
                                    <div class="site-item" v-for="site in personalInstitutions" :key="site.address" @click="onSiteClick(site)">
                                        <img :src="site.favicon" class="logo" alt="">
                                        <span class="title" :title="site.institutionName">{{ site.institutionName ?? '-' }}</span>
                                        <img src="~@/assets/img/home/current@2x.png" class="current-icon" alt="" v-if="site.current">
                                    </div>
                                </div>
                            </template>
                        </el-dropdown>
                    </div>
                    
                    
                </div>
                <div class="logout flex-center" @click="exit">
                    <i class="iconfont icon-a-tuichu1x"></i>退出登录 
                </div>
            </div>
        </template>
    </el-dropdown>
</template>

<script setup>
import { pageJump } from '@/global/location-transfer';
import { getUrl } from '@/router/jumpHref.js';
import { ref, computed, onBeforeUnmount, onMounted } from 'vue'
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import config from '@/global/config'
import CommonResourceList from '@/views/my-resource/components/Common-resource-list.vue';

const store = useStore();
const route = useRoute();

const props = defineProps({
    applications: { // 菜单
        type: Array,
        default: () => {
            return [];
        }
    },
    popperClass: { // 菜单
        type: String,
        default: () => {
            return 'user-drop-menu';
        }
    }
})
const currentUser = computed(() => {
    return store.state.currentUser || {};
})
const username = computed(() => {
    return currentUser.value?.realName || currentUser.value?.name || ''
})
const shortName = computed(() => {
    return username.value.length <= 3 ? username.value : (username.value.slice(0, 3) + '...')
})
const showManage = computed(() => { // 是否显示管理中心
    let pagePermission = store.state?.pagePermission || {};
    let isHaveIdmx = store.state.user?.isHaveIdmx;
    return !!pagePermission['manageCenter:base:home'] && isHaveIdmx;
})

const showPersonCenter = computed(() => { // 是否显示个人中心
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['personalCenter:page']
})

const showStrain = computed(() => { // 是否显示培训管理系统
    let pagePermission = store.state?.pagePermission || {};
    let isHaveStrain = store.state.user?.isHaveStrain;
    return !!pagePermission.continuingEducation && !!pagePermission.train && isHaveStrain;
})


// 是否展示用户站点信息, 切换站点
const showSiteList = computed(() => {
    let list = store.state.pagePermission['switchOtherInst']?.moduleRuleList || []
    let res = list.find(item => !!item.checked) || {};
    return res.ruleKey === 'yes';
})

// 站点列表
const personalInstitutions = computed(() => {
    return store.state.user?.personalInstitutions || [];
})

// 当前站点
const currentInstitution = computed(() => {
    return personalInstitutions.value.find(ins => !!ins.current) ?? {};
})

function exit() {
    store.dispatch('logoutHome');
   
}

function goPage (name) {
    if(name === 'userHomePage' && !showPersonCenter.value) {
        return
    }
    pageJump({ name });
}

function goSelfUrl (str) {
    let url = getUrl(str);
    pageJump(url, '_blank');
}

const userDropMenuRef = ref(null)
let mouseTimer = null;

onMounted(() => {

})

// 跳转到对应站点
function onSiteClick(site) {
    if(site.current) {
        return
    }
    const url = `https://${site.address}/idx/home`;
    pageJump(url, true);
}

function siteMenuMouseOver() {
    userDropMenuRef.value.handleOpen()
}

function siteMenuMouseLeave() {
    mouseTimer = setTimeout(() => {
        userDropMenuRef.value && userDropMenuRef.value.handleClose()
    }, 150)
}

function userDropMenuMouseOver() {
    mouseTimer && clearTimeout(mouseTimer)
    mouseTimer = null;
}

onBeforeUnmount(() => {
    mouseTimer && clearTimeout(mouseTimer)
    mouseTimer = null;
})
</script>
<style lang="scss">
// .main-drop-menu {
//     .el-dropdown-menu__item {
//         justify-content: center;
//     }
// }
.user-drop-menu {
    width: 294px !important;
    background: #FFFFFF !important;
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.1) !important;
    border-radius: 12px !important;
    .el-popper__arrow::before {
        display: none;
    }
}
.site-drop-menu {
    .el-popper__arrow::before {
        display: none;
    }
    margin-left: -50px;
}
</style>
<style lang="scss" scoped>

.pointer {
    cursor: pointer;
}
.user-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}
.user-name {
    margin-left: 6px;
    font-size: 14px;
    color: #000000;
}
.nav-item {
    display: flex;
    align-items: center;
    margin-left: 20px;
    &::after {
        content: '';
        background: url(~@/assets/img/login/head-down.png) no-repeat;
        width: 10px;
        height: 10px;
        background-size: contain;
        margin-left: 6px;
        display: inline-block;
    } 
    &:focus {
        outline: none;
    }
}
.dropdown-menu-box {
    .user-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .user-name {
        display: inline-block;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 8px;
        font-size: 16px;
        color: #000000;
        line-height: 16px;
    }
    .menu-header {
        height: 64px;
        padding: 12px;
        cursor: pointer;
        &:hover {
            .personal-nav {
                color: var(--color-primary);
                i {
                    color: var(--color-primary);
                }
            }
        }
        .personal-nav {
            font-size: 14px;
            color: #222222;
            line-height: 14px;
            cursor: pointer;
            i {
                color: #999999;
                font-size: 12px;
                line-height: 12px;
                margin-left: 6px;
            }
            &:hover {
                color: var(--color-primary);
                i {
                    color: var(--color-primary);
                }
            }
        }
    }
    .menu-box {
        padding: 0 12px;
        // border-bottom: 1px solid #E0E2E4;
    }
    .application-menu {
        background: linear-gradient(135deg, #F9FDFA 0%, #F6FCF8 100%);
        border-radius: 8px;
        border: 1px solid #E5F6ED;
        .application-header {
            padding: 12px 16px;
            font-size: 14px;
            color: #666666;
            line-height: 14px;
        }
    }
    .site-list-menu {
        background: linear-gradient(135deg, #F9FDFA 0%, #F6FCF8 100%);
        border-radius: 8px;
        border: 1px solid #E5F6ED;
        margin-top: 12px;
        padding: 13px 14px 16px 16px;
        :deep(.el-dropdown) {
            width: 100%;
        }
        .site-header {
            font-size: 14px;
            color: #666666;
            line-height: 14px;
        }
        .current-site {
            box-sizing: border-box;
            width: 100%;
            height: 22px;
            line-height: 22px;
            margin-top: 15px;
            font-size: 16px;
            color: #000000;
            display: grid;
            grid-template-columns: 20px 1fr 12px;
            grid-column-gap: 6px;
            grid-row-gap: 0px;
            align-items: center;
            .logo {
                grid-area: 1 / 1 / 2 / 2;
                width: 20px;
                height: 20px;
            }
            .title {
                grid-area: 1 / 2 / 2 / 3;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .arrow-right-icon {
                grid-area: 1 / 3 / 2 / 4;
                width: 12px;
                height: 12px;
            }
        }
    }
    
    .menu-icon {
        width: 26px;
        height: 26px;
    }
    .menu-title {
        height: 16px;
        font-size: 16px;
        color: #222222;
        line-height: 16px;
    }
    .application-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .application-title {
        height: 16px;
        font-size: 16px;
        color: #222222;
        line-height: 16px;
        margin-left: 8px;
    }
    .application-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 10px;
        .application-item {
            width: 50%;
            height: 28px;
            font-size: 16px;
            color: #222222;
            line-height: 16px;
            padding-left: 16px;
            margin-top: 8px;
            align-self: center;
            cursor: pointer;
            &:hover {
                color: #279731;
            }
        }
        .application-item:nth-child(1), .application-item:nth-child(2) {
            margin-top: 0;
        }
        // .application-item:nth-child(2n) {
        //     margin-left: 20px;
        // }
    }
    .drop-menu-item {
        height: 44px;
        background: linear-gradient(135deg, #F9FDFA 0%, #F6FCF8 100%);
        border-radius: 8px;
        border: 1px solid #E5F6ED;
        margin-top: 12px;
        padding-left: 16px;
        padding-right: 14px;
        font-size: 14px;
        color: #222222;
        cursor: pointer;
        &:nth-child(1) {
            margin-top: 0;
        }
        i {
            font-size: 12px;
            line-height: 12px;
            color: #999999;
        }
        &:hover {
            color: #279731;
            i {
                color: #279731;
            }
        }
    }
    .logout {
        height: 48px;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
        cursor: pointer;
        i {
            font-size: 16px;
            line-height: 16px;
            margin-right: 8px;
            color: #999999;
        }
        &:hover {
            color: var(--color-primary);
            i {
                color: var(--color-primary);
            }
        }
    }
}
.site-menu-box {
    width: 200px;
    background: #FFFFFF !important;
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.1) !important;
    border-radius: 10px !important;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .site-item {
        width: 100%;
        height: 30px;
        line-height: 22px;
        font-size: 16px;
        color: #000000;
        display: grid;
        grid-template-columns: 20px 1fr 14px;
        grid-column-gap: 6px;
        grid-row-gap: 0px;
        align-items: center;
        border-radius: 4px;
        padding: 0 4px;
        &:hover {
            cursor: pointer;
            background-color: #F8FDFA;
        }
        .logo {
            width: 20px;
            height: 20px;
        }
        .title {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .current-icon {
            width: 16px;
            height: 16px;
        }
    }
}
</style>